<template>
  <div class="role-games-wrapper">
    <el-input
      v-model="tree_config.filter_text"
      placeholder="输入关键词进行过滤"
      @input="tree_config.debouncedFilterTextChange"
    />
    <div v-loading="tree_config.loading">
      <p class="font-16 font-bold">角色名称：{{ rawData.name }}</p>
      <p class="font-16 font-bold">游戏权限：</p>
      <el-scrollbar style="height:400px" wrap-style="overflow-x:hidden;" class="h-full">
        <el-tree
          ref="gameTree"
          :data="tree_config.game_config.options"
          node-key="id"
          show-checkbox
          :props="tree_config.props"
          :filter-node-method="filterNodes"
          :render-content="renderContent"
        />
      </el-scrollbar>
    </div>
    <div class="text-right">
      <el-button size="mini" @click="cancel">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>

<script>
import AdvertisingResource from '@/api/advertising';
import RolesResource from '@/api/roles';
import { debounceSimple } from '@/utils';

const rolesResource = new RolesResource();
const advertisingResource = new AdvertisingResource();

export default {
  props: {
    rawData: { type: Object, default: null },
  },
  data() {
    return {
      tree_config: {
        loading: false,
        props: {
          children: 'children',
          label: 'name',
        },
        game_config: {
          options: [],
        },
        filter_text: '',
        debouncedFilterTextChange: debounceSimple(this.onFilterTextChange, 500),
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    /** 树节点的内容区的渲染 */
    renderContent(h, { node }) {
      return h('span', null, `${node.data.id} ${node.data.name}`);
    },
    /**
     * 监听关键词搜索
     * @param {string} 关键词
     */
    onFilterTextChange(val) {
      this.$refs.gameTree.filter(val);
    },
    /** 初始化数据 */
    async initData() {
      try {
        this.tree_config.loading = true;
        await this.getGameList();
        const role_games = await this.getRoleGames();
        this.$refs.gameTree.setCheckedNodes(role_games);
      } finally {
        this.tree_config.loading = false;
      }
    },
    /** 获取游戏列表 */
    getGameList() {
      return new Promise((resolve, reject) => {
        advertisingResource.getGameListApi({ refresh: 1 }).then(({ list = [] }) => {
          Object.assign(this.tree_config.game_config, { options: list });
          resolve(list);
        }).catch(reject);
      });
    },
    /**
     * 获取角色游戏接口
     * @param {number} role_id 角色id
     */
    async getRoleGames(role_id = this.rawData.id) {
      return new Promise((resolve, reject) => {
        rolesResource.getRoleGamesApi(role_id).then((response) => resolve(response.list)).catch(reject);
      });
    },
    /**
     * 关键词过滤
     * @param {number} value 关键词
     * @param {Record<string,any>} data 游戏数据
     */
    filterNodes(value, data) {
      if (!value) {
        return true;
      }
      return (`${data.id} ${data.name}`).indexOf(value) !== -1;
    },
    /** 确认更新游戏权限 */
    confirm() {
      this.tree_config.loading = true;
      const game_ids = this.$refs.gameTree.getCheckedNodes(true, false).map(({ id }) => id);
      rolesResource
        .assignGamePermissionApi(this.rawData.id, { game_ids })
        .then(({ message }) => {
          this.$message.success(message || '分配成功！');
          this.$emit('confirm');
        }).finally(() => {
          this.tree_config.loading = false;
        });
    },
    /** 取消更新游戏权限 */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
